import React from 'react';
import Shop1 from '../../components/ShopElements/Shop1';
import PageHeader from '../Shared/PageHeader';

const SingleProduct = () => {
    return (
        <div>
            <PageHeader title="Product" />
            <Shop1 />
        </div>
    );
};

export default SingleProduct;